"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Busboy = __importStar(require("busboy"));
var os_1 = __importDefault(require("os"));
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
function formMiddlware(req, res, next) {
    // See https://cloud.google.com/functions/docs/writing/http#multipart_data
    var busboy = new Busboy.default({
        headers: req.headers,
        limits: {
            // Cloud functions impose this restriction anyway
            fileSize: 10 * 1024 * 1024,
        }
    });
    var fields = {};
    var files = [];
    var fileWrites = [];
    // Note: os.tmpdir() points to an in-memory file system on GCF
    // Thus, any files in it must fit in the instance's memory.
    var tmpdir = os_1.default.tmpdir();
    busboy.on('field', function (key, value) {
        // You could do additional deserialization logic here, values will just be
        // strings
        fields[key] = value;
    });
    busboy.on('file', function (fieldname, file, filename, encoding, mimetype) {
        var filepath = path_1.default.join(tmpdir, filename);
        var fileNum = 0;
        //Add a number to the file if there are multiple of the same file.
        //Stop at 100 to stop infinite loops
        while (fs_1.default.existsSync(filepath) && fileNum <= 100) {
            fileNum += 1;
            filepath = path_1.default.join(tmpdir, filename + "_" + fileNum);
        }
        // console.log(`Handling file upload field ${fieldname}: ${filename} (${filepath})`);
        console.log("Handling file upload field " + fieldname);
        var writeStream = fs_1.default.createWriteStream(filepath);
        file.pipe(writeStream);
        fileWrites.push(new Promise(function (resolve, reject) {
            file.on('end', function () { return writeStream.end(); });
            writeStream.on('finish', function () {
                fs_1.default.readFile(filepath, function (err, buffer) {
                    var size = Buffer.byteLength(buffer);
                    console.log("File is " + size + " bytes");
                    if (err) {
                        reject(err);
                        return;
                    }
                    files.push({
                        fieldname: fieldname,
                        filename: filename,
                        content: buffer,
                        encoding: encoding,
                        mimetype: mimetype,
                        size: size,
                    });
                    try {
                        fs_1.default.unlinkSync(filepath);
                    }
                    catch (error) {
                        reject(error);
                        return;
                    }
                    resolve();
                });
            });
            writeStream.on('error', reject);
        }));
    });
    busboy.on('finish', function () {
        Promise.all(fileWrites)
            .then(function () {
            req.body = fields;
            req.files = files;
            next();
        })
            .catch(next);
    });
    busboy.end(req.rawBody);
}
exports.default = formMiddlware;
//# sourceMappingURL=form-middleware.js.map